import { render, staticRenderFns } from "./SalesSubmissionPedestal.vue?vue&type=template&id=6a9b53f6&"
import script from "./SalesSubmissionPedestal.vue?vue&type=script&lang=js&"
export * from "./SalesSubmissionPedestal.vue?vue&type=script&lang=js&"
import style0 from "./SalesSubmissionPedestal.vue?vue&type=style&index=0&id=6a9b53f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports